import styled from 'styled-components';
import { getMealPlanEvoIcon } from '@/app/components/search/components/Filters/verticalFilters/Fields/getMealPlanField/getMealPlanIcon.tsx';
import { createFilterTilesMain } from '@/app/common/filters/surfaces/forms/tiles/createFilterTilesMain.tsx';

const MEAL_PLAN_ICONS = getMealPlanEvoIcon();

const Icon = styled.span`
  display: flex;
`;

const Label = styled.span`
  text-align: center;
`;

// Three to a row on desktop and two on mobile, so five board types give 3 + 2 and 2 + 2 + 1.
export const MealPlanAllFiltersGrid = createFilterTilesMain({
  idPrefix: 'meal-plan-tile',
  perRow: { mobile: 2, desktop: 3 },
  variant: 'stacked',
  renderContent: (option) => {
    const icon = MEAL_PLAN_ICONS[Number(option.value)];

    return (
      <>
        {!!icon && <Icon aria-hidden="true">{icon}</Icon>}
        <Label>{option.label}</Label>
      </>
    );
  },
  // Named explicitly rather than left to the label content, which is a button the accessible name
  // computation reaches through a `for` attribute.
  ariaLabel: (option) => option.label,
});
